import React from 'react'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr } from 'helpers/StringNumberFunction/NumFormatters'
import { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'

export const UsefulLifeEntryList = (props: any) => {
  const { filteredList, listLoading, listStatus, fetchMore } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  let history = useHistory()
  const { CompanyID }: any = useParams()

  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [deleteAA, setDeleteAA] = useState<boolean>(false)

  return (
    <>
      {listLoading && <Loading />}
      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList).length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: listStatus,
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                return (
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          {listStatus === 'COMPLETED' ? (
                            <>
                              <span className={`xsTitle flex-space`}>
                                {el?.Name}
                              </span>
                              <span className={`xsTitle flex-space`}>
                                {el?.AssetNo}
                              </span>
                            </>
                          ) : (
                            <>
                              <span
                                className="flex-space mdLabel"
                                style={{ fontSize: '12px' }}
                              >
                                {el?.Name}
                              </span>
                              <span
                                className={`xsTitle`}
                                style={{ color: 'orange' }}
                              >
                                {el?.AssetNo}
                              </span>
                            </>
                          )}
                        </>
                      }
                      secondary={
                        <>
                          <Grid container>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={6}>
                                <span className="desc flex-space">
                                  {`Useful Life: `}
                                  <span
                                    style={{ textDecoration: 'line-through' }}
                                  >
                                    {el?.InitialValue}
                                  </span>
                                  <span style={{ color: 'orange' }}>
                                    &#10230;
                                  </span>
                                  <span
                                    style={{ color: 'limegreen' }}
                                  >{` ${amtNumStr(el?.UpdatedValue)}`}</span>
                                </span>
                              </Grid>
                              <Grid item xs={6} style={{ textAlign: 'right' }}>
                                {!!el?.Date ? formatDate(el?.Date) : ''}
                              </Grid>
                            </Grid>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={12} className="desc">
                                <span>{el?.Description}</span>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      {listStatus === 'ACTIVE' || listStatus === 'REJECTED' ? (
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          aria-controls="menu-list"
                          aria-haspopup="true"
                          onClick={e => handleClick(e, el?.ID, index, el)}
                        >
                          <MoreVert />
                        </IconButton>
                      ) : (
                        <IconButton edge="end" aria-label="arrow">
                          <KeyboardArrowRight
                            onClick={() =>
                              history.push({
                                pathname: `/fixed-assets/${CompanyID}/assets-change/useful-life/${el?.ID}/detail`,
                                state: el,
                              })
                            }
                          />
                        </IconButton>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && (
          <FloatButton
            onClick={() =>
              history.push(
                `/fixed-assets/${CompanyID}/assets-change/useful-life/add`
              )
            }
          />
        )}
      </ContentWrapper>

      {listStatus === 'ACTIVE' ? (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/useful-life/${menu?.ibj.ID}/edit`,
                state: menu,
              })
            }}
          >
            <span>Edit</span>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setDeleteAA(true)
            }}
          >
            <span>Delete</span>
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/useful-life/${menu?.obj.ID}/edit`,
                state: menu?.obj,
              })
            }}
          >
            <span>Resubmit</span>
          </MenuItem>
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteAA}
        setOpenDeleteDialog={setDeleteAA}
        title={'Useful Life'}
        menu={menu?.obj}
        passID={menu?.ID}
      />
      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={
          'You cannot delete this entry because it is already in use.'
        }
      />
    </>
  )
}
